"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateVatAmount = exports.calculateNetAmount = exports.calculateGrossAmount = void 0;
const types_1 = require("./types");
const calculateGrossAmount = ({ officeAreaShare, adjustByOfficeAreaShare, period, amount, monthsUsed, }) => {
    const share = adjustByOfficeAreaShare ? officeAreaShare : 1;
    let grossAmount = 0;
    switch (period) {
        case types_1.HomeOfficeExpensePeriod.MONTHLY:
            grossAmount = Math.floor(amount * monthsUsed * share);
            break;
        case types_1.HomeOfficeExpensePeriod.ANNUAL:
            grossAmount = Math.floor((amount * monthsUsed * share) / 12);
            break;
        case types_1.HomeOfficeExpensePeriod.ONE_TIME_PAYMENT:
            grossAmount = Math.floor(amount * share);
            break;
        default:
            grossAmount = 0;
    }
    return grossAmount;
};
exports.calculateGrossAmount = calculateGrossAmount;
const calculateNetAmount = ({ officeAreaShare, adjustByOfficeAreaShare, period, amount, monthsUsed, vatRate, }) => {
    const grossAmount = (0, exports.calculateGrossAmount)({
        officeAreaShare,
        adjustByOfficeAreaShare,
        period,
        amount,
        monthsUsed,
    });
    return Math.floor(grossAmount / (1 + vatRate / 100));
};
exports.calculateNetAmount = calculateNetAmount;
const calculateVatAmount = ({ officeAreaShare, adjustByOfficeAreaShare, period, amount, monthsUsed, vatRate, }) => {
    const grossAmount = (0, exports.calculateGrossAmount)({
        officeAreaShare,
        adjustByOfficeAreaShare,
        period,
        amount,
        monthsUsed,
    });
    const netAmount = (0, exports.calculateNetAmount)({
        officeAreaShare,
        adjustByOfficeAreaShare,
        period,
        amount,
        monthsUsed,
        vatRate,
    });
    return grossAmount - netAmount;
};
exports.calculateVatAmount = calculateVatAmount;
//# sourceMappingURL=expenseAmounts.js.map